import { LOCATION_FETCH_REQUEST, LOCATION_FETCH_SUCCESS, LOCATION_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchLocationRequest = () => {
    return {
        type: LOCATION_FETCH_REQUEST
    }
}

const fetchLocationSuccess = location => {
    return {
        type: LOCATION_FETCH_SUCCESS,
        payload: location,
    }
}

const fetchLocationFailure = error => {
    return {
        type: LOCATION_FETCH_FAILURE,
        payload: error,
    }
}

export const getLocation = (shootType) => {
    return (dispatch) => {
        dispatch(fetchLocationRequest());
        fetch(`${baseUrl}/shoot_locations?shoot_type_id=${shootType}`, {
                method: 'GET'
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchLocationSuccess(response));
            })
            .catch((error) => {
                dispatch(fetchLocationFailure(error.message));
            })
    }
}